<div class="min-h-screen bg-cartco-mist text-slate-900 dark:bg-slate-900 dark:text-slate-100">
  <!-- Mobile overlay -->
  <div
    class="fixed inset-0 z-30 bg-slate-900/60 backdrop-blur-sm transition-opacity lg:hidden"
    *ngIf="isMobileDrawerOpen()"
    (click)="closeMobileSidebar()"
  ></div>

  <!-- Sidebar -->
  <aside
    class="fixed inset-y-0 left-0 z-40 flex w-72 flex-col bg-white shadow-2xl shadow-slate-900/10 transition-transform dark:bg-slate-950"
    [ngClass]="{
      '-translate-x-full': !isSidebarOpen(),
      'translate-x-0': isSidebarOpen()
    }"
  >
    <div class="flex items-center gap-3 border-b border-slate-100 px-6 py-5 dark:border-slate-800">
      <!-- CartCo Logo -->
      <div class="flex items-center gap-2 shrink-0">
        <img src="/assets/i18n/logo.png" alt="CartCo Logo" class="h-20 w-auto object-contain">
      </div>
      <div>
        <p class="text-sm font-semibold tracking-wide text-slate-700 dark:text-slate-200">Admin</p>
        <p class="text-xs text-slate-400">Control Center</p>
      </div>
    </div>

    <nav class="flex-1 overflow-y-auto px-4 py-6">
      <ng-container *ngFor="let section of navSections(); trackBy: trackSection">
        <p class="px-3 text-xs font-semibold uppercase tracking-wide text-slate-400 dark:text-slate-500">
          {{ section.title }}
        </p>
        <div class="mt-2 flex flex-col gap-1">
          <a
            *ngFor="let item of section.items; trackBy: trackNavItem"
            [routerLink]="item.route"
            [routerLinkActiveOptions]="item.exactPath ? { exact: true } : { exact: false }"
            routerLinkActive="bg-cartco-green/10 text-cartco-green dark:bg-slate-800"
            class="group flex items-center gap-3 rounded-xl px-3 py-2 text-sm font-medium text-slate-600 transition hover:bg-slate-100 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-white"
            (click)="closeMobileSidebar()"
          >
            <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-slate-100 text-slate-500 transition group-hover:bg-cartco-green/10 group-hover:text-cartco-green dark:bg-slate-800 dark:text-slate-400">
              <ng-container [ngSwitch]="item.icon">
                <svg *ngSwitchCase="'dashboard'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
                  <path d="M3 13h8V3H3z" /><path d="M13 21h8V11h-8z" /><path d="M13 3v6h8V3z" /><path d="M3 21v-6h8v6z" />
                </svg>
                <svg *ngSwitchCase="'pos'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
                  <path d="M4 7h16" /><path d="M6 3h12" /><rect width="18" height="12" x="3" y="7" rx="2" /><path d="M8 11h3v3H8z" />
                </svg>
                <svg *ngSwitchCase="'orders'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
                  <path d="M4 5h16" /><path d="M4 12h16" /><path d="M4 19h16" /><path d="M8 5v14" />
                </svg>
                <svg *ngSwitchCase="'promotions'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
                  <path d="M4 11.5A2.5 2.5 0 0 1 6.5 9H20l-4.5 7H6.5A2.5 2.5 0 0 1 4 13.5z" /><path d="M8 9V5" /><path d="M12 9V3" /><path d="M16 9V5" />
                </svg>
                <svg *ngSwitchCase="'coupons'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
                  <path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L3 13V4h9l8.59 8.59a2 2 0 0 1 0 2.82z" /><circle cx="7.5" cy="7.5" r="1.5" />
                </svg>
                <svg *ngSwitchCase="'products'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
                  <path d="M12 2 3 7l9 5 9-5-9-5z" /><path d="M3 17l9 5 9-5" /><path d="M3 12l9 5 9-5" />
                </svg>
                <svg *ngSwitchCase="'categories'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
                  <rect x="3" y="3" width="7" height="7" rx="1.5" />
                  <rect x="14" y="3" width="7" height="7" rx="1.5" />
                  <rect x="3" y="14" width="7" height="7" rx="1.5" />
                  <rect x="14" y="14" width="7" height="7" rx="1.5" />
                </svg>
                <svg *ngSwitchCase="'stores'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
                  <path d="M3 9l1.5-6h15L21 9" /><path d="M3 9h18v12H3z" /><path d="M9 13h6v8H9z" />
                </svg>
                <svg *ngSwitchCase="'reports'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
                  <path d="M3 3h18v18H3z" /><path d="M7 17v-6" /><path d="M12 17V7" /><path d="M17 17v-3" />
                </svg>
                <svg *ngSwitchCase="'settings'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
                  <circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9c0 .69.4 1.31 1.02 1.58.18.08.38.12.58.12H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
                </svg>
                <svg *ngSwitchCase="'notifications'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
                  <path d="M6 8a6 6 0 1 1 12 0c0 .5.1.9.21 1.32L19 11" /><path d="M5 19h14l-1.73-7.73A2 2 0 0 0 15.33 10H8.67a2 2 0 0 0-1.94 1.27L5 19z" /><path d="M13.73 21a2 2 0 0 1-3.46 0" />
                </svg>
                <svg *ngSwitchCase="'delivery'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
                  <path d="M3 7h13v7H3z" /><path d="M16 10h3l2 3v4h-5z" /><circle cx="7.5" cy="17.5" r="1.5" /><circle cx="18.5" cy="17.5" r="1.5" /><path d="M5 7V5h4" />
                </svg>
                <svg *ngSwitchCase="'incidents'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
                  <path d="M12 9v4" /><path d="M12 17h.01" /><path d="m10.29 3.86-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.71-3.14l-8-14a2 2 0 0 0-3.42 0z" />
                </svg>
                <svg *ngSwitchCase="'users'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
                <svg *ngSwitchCase="'parcel'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><polyline points="3.27 6.96 12 12.01 20.73 6.96" /><line x1="12" y1="22.08" x2="12" y2="12" />
                </svg>
                <svg *ngSwitchCase="'analytics'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
                  <path d="M3 3v18h18" /><path d="M18 7l-5 5-4-4-3 3" />
                </svg>
                <svg *ngSwitchCase="'serviceZone'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
                  <path d="M12 21s-8-4.5-8-11a8 8 0 1 1 16 0c0 6.5-8 11-8 11z" />
                  <circle cx="12" cy="10" r="2.5" />
                </svg>
              </ng-container>
            </span>
            <span class="flex-1">{{ item.label }}</span>
            <span *ngIf="item.badge" class="rounded-full bg-cartco-orange/10 px-2 text-xs font-semibold text-cartco-orange">
              {{ item.badge }}
            </span>
          </a>
        </div>

        <div class="mb-6"></div>
      </ng-container>
    </nav>

    <div class="border-t border-slate-100 px-6 py-5 dark:border-slate-800">
      <button
        type="button"
        class="flex w-full items-center justify-between rounded-xl bg-slate-100/80 px-4 py-3 text-sm font-medium text-slate-600 transition hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:hover:bg-slate-700"
        (click)="signOut()"
      >
        <span>Sign out</span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
          <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" /><path d="M10 17 15 12 10 7" /><path d="M15 12H3" />
        </svg>
      </button>
    </div>
  </aside>

  <!-- Main -->
  <div [ngClass]="{ 'lg:pl-72': isDesktopLayout() && isSidebarPinned() }">
    <header class="sticky top-0 z-20 flex items-center gap-3 border-b border-slate-200/60 bg-white/80 px-5 py-4 backdrop-blur dark:border-slate-800 dark:bg-slate-950/70">
      <button
        *ngIf="showSidebarMenuButton()"
        type="button"
        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 shadow-sm transition hover:border-cartco-green hover:text-cartco-green dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300"
        (click)="toggleSidebar()"
        aria-label="Open menu"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
          <path d="M3 6h18" /><path d="M3 12h18" /><path d="M3 18h18" />
        </svg>
      </button>

      <div *ngIf="showZoneFilter()" class="flex min-w-0 flex-1 items-center justify-end sm:justify-start">
        <label class="flex min-w-0 max-w-md flex-1 items-center gap-2 text-sm text-slate-600 dark:text-slate-300">
          <span class="shrink-0 hidden sm:inline">Zone</span>
          <select
            class="min-w-0 flex-1 rounded-xl border border-slate-200 bg-white py-2 pl-3 pr-8 text-sm font-medium text-slate-800 outline-none transition focus:border-cartco-green focus:ring-2 focus:ring-cartco-green/20 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100"
            [value]="zoneFilter.selectedZoneId()"
            (change)="onZoneChange($event)"
          >
            <option value="all">All zones</option>
            <option *ngFor="let z of zones(); trackBy: trackZoneById" [value]="z.id">{{ z.name }}</option>
          </select>
        </label>
      </div>
      <div
        *ngIf="showAssignedZoneReadonly()"
        class="flex min-w-0 flex-1 items-center gap-2 text-sm text-slate-600 dark:text-slate-300"
        [title]="assignedZoneDisplay()"
      >
        <span class="shrink-0 font-medium text-slate-500 dark:text-slate-400">Service zone</span>
        <span
          class="min-w-0 truncate rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm font-semibold text-slate-800 dark:border-slate-700 dark:bg-slate-800/80 dark:text-slate-100"
        >
          {{ assignedZoneDisplay() }}
        </span>
      </div>
      <div *ngIf="!showZoneFilter() && !showAssignedZoneReadonly()" class="min-w-0 flex-1"></div>

      <button
        type="button"
        class="flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 shadow-sm transition hover:border-cartco-green hover:text-cartco-green dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300"
        (click)="toggleTheme()"
      >
        <ng-container *ngIf="isDark(); else sunIcon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
            <path d="M21 12.79A9 9 0 1 1 11.21 3a7 7 0 0 0 9.79 9.79z" />
          </svg>
        </ng-container>
        <ng-template #sunIcon>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
            <circle cx="12" cy="12" r="4" /><path d="M12 2v2" /><path d="M12 20v2" /><path d="m4.93 4.93 1.41 1.41" /><path d="m17.66 17.66 1.41 1.41" /><path d="M2 12h2" /><path d="M20 12h2" /><path d="m6.34 17.66-1.41 1.41" /><path d="m19.07 4.93-1.41 1.41" />
          </svg>
        </ng-template>
      </button>

      <div class="hidden items-center gap-3 rounded-xl border border-slate-200 bg-white px-4 py-2 text-left text-sm font-medium text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 md:flex">
        <div class="h-9 w-9 rounded-full bg-cartco-green/10 text-cartco-green ring-4 ring-cartco-green/20 dark:bg-cartco-green/20 dark:text-white dark:ring-cartco-green/10 flex items-center justify-center font-semibold">
          {{ userInitials() }}
        </div>
        <div class="leading-tight">
          <p>{{ profile()?.name || 'Admin User' }}</p>
          <p class="text-xs font-medium text-slate-400 dark:text-slate-500">{{ userEmail() }}</p>
        </div>
      </div>
    </header>

    <main class="min-h-[calc(100vh-4rem)] bg-transparent px-5 py-6">
      <div class="mx-auto max-w-7xl">
        <router-outlet />
      </div>
    </main>
  </div>
</div>
